var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"relative"},[_c('app-footer-city',{attrs:{"configuration":_vm.configuration}}),_c('app-footer-brand')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }